import axios from '../../../../../redux/my-axios';

export const ORDERS_URL = '/orders';

// READ
export function findOrders(queryParams) {
  //console.log(queryParams);
  return axios.post(ORDERS_URL, queryParams, { headers: { action: 'find' } });
}

export function getOrder(orderCode) {
  return axios.post(ORDERS_URL, orderCode, { headers: { action: 'get' } });
}

export function createOrder(orderForCreate) {
  return axios.post(ORDERS_URL, orderForCreate, {
    headers: { action: 'post' },
  });
}

export function updateOrder(orderForView) {
  return axios.post(ORDERS_URL, orderForView, { headers: { action: 'put' } });
}

export function deleteOrder(orderCode) {
  return axios.post(ORDERS_URL, orderCode, { headers: { action: 'delete' } });
}
